export default __webpack_public_path__ + "static/media/home_icon.1a06227a.svg";